export enum Resolution {
	HIGH,
	MEDIUM,
	LOW
}
